<!--
 * @Author: Jason
 * @Date: 2020-09-11 14:03:51
 * @LastEditors: Jason
 * @LastEditTime: 2020-09-11 14:14:40
-->
<template>
  <div id="app">
    <div v-if="LoginInfo.checkIsLogin"></div>
    <div style="width: 100%; height: 100%;" :class="{'hide-view': LoginInfo.checkIsLogin}">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import bus from './common/bus';
  export default {
    name: 'ms',
    components: {
    },
    computed: {
      ...mapState([
      	'LoginInfo'
      ])
    },
    watch: {
    	'LoginInfo.signed' (val) {
         console.log(val)
      }
    },
    created () {
      this.checkLogin()
      bus.$on('showModal', this.alertMsg)
      bus.$on('logout', this.logout)
    },
    methods: {
    	async checkLogin () {
        const token = localStorage.token
        if (!token) return false
        let payload = {}
        this.$store.dispatch('checkLogin', {token})
        try {
          const res = await this.$api.checkLoginInfo({
            token
          })

          const data = res.data
          if (data.ok) {
            payload.account = data.result
            payload.signed = true
            payload.token = token
            if (this.$route.name === 'Login') {
              this.$router.replace({name: 'Home'})
            }
          } else {
            payload.signed = false
            if (this.$route.name !== 'Login') {
              this.$router.replace({name: 'Login'})
            }
          }
        } catch (e) {
          console.log(e)
        }
        this.$store.dispatch('loginFinish', payload)
      },
      alertMsg (options) {
        this.$alert(options.msg, {
          confirmButtonText: '确定',
          showClose: false,
          callback: action => {
            options.callback && options.callback()
          }
        });
      },
      logout () {
        this.$api.logout()
        this.$store.dispatch('logout')
        this.$router.replace({name: 'Login'})
      }
    }
  }
</script>

<style lang="less">
  /* CSS */
  @import './less/common.less';
  @import './less/reset.less';

  @import "./assets/css/main.css";
  @import "./assets/css/font_icon.css";
  @import "./assets/css/color-dark.css";     /*深色主题*/
  #app {
    width: 100vw;
    height: 100vh;

  }
  .hide-view {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue